import { render, staticRenderFns } from "./modal-confirmar-cancelamento.vue?vue&type=template&id=22027958&scoped=true"
import script from "./modal-confirmar-cancelamento.vue?vue&type=script&lang=js"
export * from "./modal-confirmar-cancelamento.vue?vue&type=script&lang=js"
import style0 from "./modal-confirmar-cancelamento.vue?vue&type=style&index=0&id=22027958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22027958",
  null
  
)

export default component.exports